function getViewportSize() {
  return {
    width: window.innerWidth || document.documentElement.clientWidth,
    height: window.innerHeight || document.documentElement.clientHeight,
  };
}

/**
 * Returns true when the whole element is inside the viewport.
 */
export function isElementInViewport(element) {
  if (!element) return false;

  const rect = element.getBoundingClientRect();
  const viewport = getViewportSize();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= viewport.height &&
    rect.right <= viewport.width
  );
}

/**
 * Returns true when any part of an element intersects the viewport.
 */
export function isElementPartiallyInViewport(element) {
  if (!element) return false;

  const rect = element.getBoundingClientRect();
  const viewport = getViewportSize();

  return (
    rect.top < viewport.height &&
    rect.bottom > 0 &&
    rect.left < viewport.width &&
    rect.right > 0
  );
}
